export const PERMISSION = {
  ADD: 'RETURNCONDITION_ADD',
  EDIT: 'RETURNCONDITION_EDIT',
  VIEW: 'RETURNCONDITION_VIEW',
  DEL: 'RETURNCONDITION_DEL',
};
